import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./Panel.styled";
export const PanelFooter = forwardRef((props, _ref) => {
    const { children, ...otherProps } = props;
    return _jsx(Styled.Footer, { ...otherProps, children: children });
});
